import type { BaseRouteType, BaseMethodType } from '../types.ts'
import { z } from "zod";
export const tagsGetAdminBuildings_buildingIdHeatingStations = z.any()
export type TagsGetAdminBuildings_buildingIdHeatingStations = z.infer<typeof tagsGetAdminBuildings_buildingIdHeatingStations>

export const paramsGetAdminBuildings_buildingIdHeatingStations = z.object({ "buildingId": z.string().uuid() })
export type ParamsGetAdminBuildings_buildingIdHeatingStations = z.infer<typeof paramsGetAdminBuildings_buildingIdHeatingStations>

export const responseGetAdminBuildings_buildingIdHeatingStations = z.object({ "payload": z.object({ "stations": z.array(z.object({ "id": z.string(), "name": z.string(), "latitude": z.number(), "longitude": z.number(), "elevation": z.union([z.number(), z.null()]), "observedFrom": z.union([z.string().date(), z.null()]), "observedTo": z.union([z.string().date(), z.null()]) })), "error": z.union([z.string(), z.null()]), "refreshing": z.boolean() }).optional(), "errors": z.any(), "message": z.string().optional() })
export type ResponseGetAdminBuildings_buildingIdHeatingStations = z.infer<typeof responseGetAdminBuildings_buildingIdHeatingStations>

interface IGetAdminBuildings_buildingIdHeatingStations extends BaseMethodType {
  tags: TagsGetAdminBuildings_buildingIdHeatingStations,
  params: ParamsGetAdminBuildings_buildingIdHeatingStations,
  response: ResponseGetAdminBuildings_buildingIdHeatingStations
}
export const URL = '/admin/buildings/:buildingId/heating/stations'
export const validation = {
  get: {
    tags: tagsGetAdminBuildings_buildingIdHeatingStations,
    params: paramsGetAdminBuildings_buildingIdHeatingStations,
    response: responseGetAdminBuildings_buildingIdHeatingStations
  }
}
export interface AdminBuildings_buildingIdHeatingStations extends BaseRouteType {
  get: IGetAdminBuildings_buildingIdHeatingStations
}